import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import {HttpClient, HttpParams} from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateLegalEntityClientModel,
  DeleteLegalEntityClientModel,
  SearchLegalEntityClientModel,
} from '../../../models/medic.model'

@Injectable({
  providedIn: 'root',
})
export class MonitoringService {
  private baseUrl = environment.baseUrl
  private resource: string = 'Monitoramento'

  constructor(private httpClient: HttpClient) {}
  public webhookGustavo(): Observable<ResponseRequestModel> {
    let array = [{},{},{}]
    const randomNumber = Math.floor(Math.random() * 201);
    console.log(randomNumber);

    let model = {
      "numero_serial": "123",
        "deviceTime": new Date().toISOString(),
        "sensorGlucose": randomNumber,
        "unit": "mmol/L",
        "warning": "high glucose classification"
      }
      console.log(model)
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}`, model)
  }
  public createPatient(
    model: any,
    // model: CreateLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}paciente/create`,
      model,
    )
  }
  public createMonitoring(
    model: any,
    // model: CreateLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }
  public createMonitoringForPatient(
    model: any,
    // model: CreateLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create-para-paciente`,
      model,
    )
  }
  public editMonitoringForPatient(
    model: any,
    // model: CreateLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.put<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/update-simples`,
      model,
    )
  }
  public editLegalEntityClient(
    model: any,
    // model: EditLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.put<ResponseRequestModel>(
      `${this.baseUrl}Paciente/update`,
      model,
    )
  }

  public finishMonitoring(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.put<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/FinalizarMonitoramento`,
      model,
    )
  }

  public listPagedLegalEntityClient(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedLegalEntityClientBySubClientId(
    subClientId: number,
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/associado-subcliente/${subClientId}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedNotLegalEntityClientBySubClientId(
    subClientId: number,
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/desassociado-subcliente/${subClientId}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listLegalEntityClient(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/list`,
    )
  }
  public listPagedAndSearchedName(page: number, rows = 10, model: any): Observable<ResponseRequestModel> {
    let params = new HttpParams()
      .set('page', page)
      .set('per_page', rows);

    // adiciona apenas os campos que têm valor válido
    for (const key in model) {
      const value = model[key];
      if (value !== null && value !== undefined && value !== '' && value !== 0) {
        params = params.set(key, value);
      }
    }
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/paginated`,
      { params }
    );
  }

  public getPatientbyId(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/find/${id}`,
    )
  }
  public measuresByPatient(id: number): Observable<ResponseRequestModel>{
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}medicao/paciente/${id}`,)
  }

  public searchPagedLegalEntityClient(
    page: number,
    rows: number = 15,
    model: SearchLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public searchPagedLegalEntityClientAssociateBySubClient(
    page: number,
    rows: number = 15,
    model: SearchLegalEntityClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated/associado-subcliente?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
